import BaseComponent from 'scripts/components/base-component'

class SignSocial extends BaseComponent {
  static componentName = 'sign-social'
  static DOMEvents = {
    submit: 'onSubmit'
  }

  init () {
    this.getFormValidation()
  }

  getFormValidation () {
    if (this.validation) {
      return
    }
    this.validation = this.$element.data('validation')
  }

  onSubmit (e) {
    e.preventDefault()

    if (this.validation.validateAll()) {
      this.$element[0].submit()
    }
  }
}

export default ($el) => new SignSocial($el).init()

export { SignSocial as Component }
